import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getOrgUsersByType} from "root/DataFunctions/DashboardDataFns";
import {getPanelHeader} from "root/dashboard/DashboardPanelFunctions";

const DashboardPanelOrgUsers = (props) =>
{
	const [data, setData] = useState({loading: true, data: []});

	useEffect(() =>
	{
		getServerData();
	}, [props.user_type, props.month]);

	const generateDataPoints = (items) =>
	{
		return items.map((item) =>
			{
				return ({
					y: Number(item.count),
					label: item.typeName,
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getOrgUsersByType(props.team_id, (response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanelHorizontal = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			title: {
				text: props.title
			},
			axisX: {
				interval: 1,
				labelFontSize: 14
			},
			axisY2: {
				gridColor: "rgba(1,77,101,.1)",
				title: props.title,
				chartlabelFontSize: 14
			},
			data: [
				{
					type: 'column',
					axisYType: "primary",
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'User Type',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			]
		};

		return (
			<div className={'panel ' + props.panelStyle}>
				{getPanelHeader({title: ''})}
				<div className='panel-body'>
					<CanvasJSChart id='chartOrgUsers' options={options} uniqueId='chartOrgUsers'/>
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanelHorizontal();
}

export default DashboardPanelOrgUsers;

DashboardPanelOrgUsers.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}